const stretchCalculatorUrl = '/docs/StretchFactor.pdf'

export {
  stretchCalculatorUrl,
}
